import { History } from 'history';

import { getDefaultPageSize } from '../globals';
import { ListFilterType } from '../fms.core/constants';

export const FilterStorageVersion = 1;

export interface SearchExtra {
  general: string|null,
  date: string|null,
  number: string|null,
  generalText: string|null,
  dateFrom: string|null,
  dateTo: string|null,
  numberFrom: number|null,
  numberTo: number|null,
};

export interface Search {
  general1: string|null,
  general2: string|null,
  general3: string|null,
  date: string|null,
  date1: string|null,
  date2: string|null,
  location1: string|null,
  location2: string|null,
  location3: string|null,
  number: string|null,
  number1: string|null,
  number2: string|null,
  generalText1: string|null,
  generalText2: string|null,
  generalText3: string|null,
  generalNullOrEmpty: boolean,
  dateFrom: string|null,
  dateTo: string|null,
  dateFrom1: string|null,
  dateTo1: string|null,
  dateFrom2: string|null,
  dateTo2: string|null,
  dateNullOrEmpty: boolean,
  location1Text: string|null,
  location2Text: string|null,
  location3Text: string|null,
  numberFrom: number|null,
  numberTo: number|null,
  numberFrom1: number|null,
  numberTo1: number|null,
  numberFrom2: number|null,
  numberTo2: number|null,
  numberNullOrEmpty: boolean,
  pageSize: number,
  orderBy: string|null,
  orderByAscending: boolean,
  extras: Array<SearchExtra>,
  version: number,
  listType: ListFilterType,
  isSearchByReport: boolean,
  isExpressSearch: boolean,
  extraWhere: string,
  listType2: number,
};

export const initialSearch:Search = {
  general1: '',
  general2: '',
  general3: '',
  date: '',
  date1: '',
  date2: '',
  location1: '',
  location2: '',
  location3: '',
  number: '',
  number1: '',
  number2: '',
  generalText1: '',
  generalText2: '',
  generalText3: '',
  generalNullOrEmpty: false,
  dateFrom: null,
  dateTo: null,
  dateFrom1: null,
  dateTo1: null,
  dateFrom2: null,
  dateTo2: null,
  location1Text: '',
  location2Text: '',
  location3Text: '',
  numberFrom: null,
  numberTo: null,
  numberFrom1: null,
  numberTo1: null,
  numberFrom2: null,
  numberTo2: null,
  numberNullOrEmpty: false,
  pageSize: getDefaultPageSize(),
  orderBy: null,
  orderByAscending: false,
  extras: [],
  version: 1,
  dateNullOrEmpty: false,
  listType: 0,
  isSearchByReport: false,
  isExpressSearch: false,
  extraWhere: '',
  listType2: 0,
};

function hasValue(x:any) {
  if (x === null || x === undefined) {
    return false;
  }

  if (typeof x !== 'number') {
    return !!x;
  }

  return true;
}

function hasExtras(e:Array<SearchExtra>) {
  if (!e || e.length <= 0) {
    return false;
  }

  return e.some(x =>
    (hasValue(x.general)/* && hasValue(x.generalText)*/) ||
    (hasValue(x.date)/* && (hasValue(x.dateFrom) || hasValue(x.dateTo))*/) ||
    (hasValue(x.number)/* && (hasValue(x.numberFrom) || hasValue(x.numberTo))*/)
  );
}

export function isFilterObjectEmpty(filter:Search|null) {
  if (!filter) {
    return true;
  }

  return !(
    (hasValue(filter.generalNullOrEmpty)) ||
    (hasValue(filter.dateNullOrEmpty)) ||
    (hasValue(filter.numberNullOrEmpty)) ||
    (hasValue(filter.general1)/* && hasValue(filter.generalText1)*/) ||
    (hasValue(filter.general2)/* && hasValue(filter.generalText2)*/) ||
    (hasValue(filter.general3)/* && hasValue(filter.generalText3)*/) ||
    (hasValue(filter.date)/* && (hasValue(filter.dateFrom) || hasValue(filter.dateTo))*/) ||
    (hasValue(filter.date1)/* && (hasValue(filter.dateFrom1) || hasValue(filter.dateTo1))*/) ||
    (hasValue(filter.date2)/* && (hasValue(filter.dateFrom2) || hasValue(filter.dateTo2))*/) ||
    (hasValue(filter.number)/* && (hasValue(filter.numberFrom) || hasValue(filter.numberTo))*/) ||
    (hasValue(filter.number1)/* && (hasValue(filter.numberFrom1) || hasValue(filter.numberTo1))*/) ||
    (hasValue(filter.number2)/* && (hasValue(filter.numberFrom2) || hasValue(filter.numberTo2))*/) ||
    (hasValue(filter.location1)/* && hasValue(filter.location1Text)*/) ||
    (hasValue(filter.location2)/* && hasValue(filter.location2Text)*/) ||
    (hasValue(filter.location3)/* && hasValue(filter.location3Text)*/) ||
    (hasExtras(filter.extras)) ||
    (hasValue(filter.extraWhere))
  );
}

export function getInitialSearch(history:History, currentUser:string|null) {
  const result = initialSearch;

  //const locationState = history.location?.state as any;
  // if (history && locationState?.metadata?.filterMyOnly === true) {
  //   result.general2 = 'updatedBy';
  //   result.generalText2 = currentUser;
  // }

  return result;
}
